export default {
  it: {
    footer: {
      location: `Via Vandalino 15/E<br />10123 Torino (IT)`,
      phone: `Telefono: {phone}`,
      email: `E-mail: {email}`
    }
  }
}
